/* eslint-disable no-console */
import {create} from 'zustand';
import Cookies from 'js-cookie';
import {LocationStore} from './types';
import {
	DEFAULT_LOCATION,
	DEFAULT_ODONTO_LOCATION,
	DEFAULT_AUTHORIZATION_LOCATION,
	COOKIE_NAMES,
	FlowType,
} from './constants';

export const useLocationStore = create<LocationStore>((set, get) => ({
	locations: {},

	getLocation: (cdPessoa, type) => {
		const cookieFn = COOKIE_NAMES[type];
		if (!cookieFn) return DEFAULT_LOCATION;

		const locationKey = cookieFn(cdPessoa);
		const stateLocation = get().locations[locationKey];
		if (stateLocation) {
			return stateLocation;
		}

		const cookie = Cookies.get(cookieFn(cdPessoa));
		let locationData;

		if (cookie) {
			try {
				locationData = JSON.parse(cookie);
			} catch (e) {
				console.error('Invalid location cookie:', e);
			}
		}

		if (!locationData) {
			switch (type) {
				case FlowType.ODONTO:
					locationData = DEFAULT_ODONTO_LOCATION;
					break;
				case FlowType.EXAM:
					locationData = DEFAULT_LOCATION;
					break;
				case FlowType.AUTHORIZATION:
					locationData = DEFAULT_AUTHORIZATION_LOCATION;
					break;
				case FlowType.HEALTH_GUIDE:
					locationData = DEFAULT_LOCATION;
					break;
				case FlowType.ODONTO_GUIDE:
					locationData = DEFAULT_ODONTO_LOCATION;
					break;
				case FlowType.DEFAULT:
				default:
					locationData = DEFAULT_LOCATION;
					break;
			}
		}

		set(state => ({
			locations: {
				...state.locations,
				[locationKey]: locationData,
			},
		}));

		return locationData;
	},

	setLocation: (cdPessoa, type, data) => {
		const cookieFn = COOKIE_NAMES[type];

		const locationKey = cookieFn(cdPessoa);

		set(state => ({
			locations: {
				...state.locations,
				[locationKey]: data,
			},
		}));

		if (!cookieFn) return;

		try {
			Cookies.set(cookieFn(cdPessoa), JSON.stringify(data), {
				expires: 99999,
				secure: true,
			});
		} catch (e) {
			console.error('Failed to store location cookie:', e);
		}
	},

	resetLocation: (cdPessoa, type) => {
		const locationKey = `${cdPessoa}_${type}`;
		const cookieFn = COOKIE_NAMES[type];

		set(state => {
			const newLocations = {...state.locations};
			delete newLocations[locationKey];
			return {locations: newLocations};
		});

		if (!cookieFn) return;
		Cookies.remove(cookieFn(cdPessoa));
	},
}));
